import { render } from "./EditMedicationDialog.vue?vue&type=template&id=0f424ec6"
import script from "./EditMedicationDialog.vue?vue&type=script&lang=js"
export * from "./EditMedicationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__